module.exports = __webpack_public_path__ + "img/cover-bg-3.ef6ac889.png";